import { createForm, useCreateFormStore } from '@components/form';
import { hideModal, Modal, useModal } from '@components/modal';
import { useScopedTranslate } from '@locale/translate';

import { useDuplicateFormTemplate } from 'api/forms/hooks';
import { ListFormTemplate } from 'api/forms/requests';

export const useDuplicateFormTemplateModal = () => useModal(DuplicateFormTemplateModal);

const Form = createForm<{ name: string }>();

export const DuplicateFormTemplateModal = ({ template }: { template: ListFormTemplate }) => {
  const { t } = useScopedTranslate(locale);
  const formStore = useCreateFormStore();
  const duplicateMutation = useDuplicateFormTemplate(template.shortId);
  const handleSubmit = async () => {
    await duplicateMutation.mutateAsync(formStore.getState().values as { name: string });
    hideModal();
  };

  return (
    <Modal>
      <Modal.SimpleHeader title={t('title')} />
      <Form store={formStore} onSubmit={handleSubmit}>
        <Modal.Content>
          <Form.TextField
            id="name"
            label={t('formName')}
            defaultValue={`${template.name} [${t('copy')}]`}
          />
        </Modal.Content>
        <Modal.Footer>
          <Form.Actions>
            <Form.Reset
              text={t('core.cancel')}
              variant="secondary"
              onClick={hideModal}
              isDisabled={duplicateMutation.isLoading}
            />
            <Form.Submit
              text={t('confirm')}
              variant="primary-blue"
              isDisabled={duplicateMutation.isLoading}
            />
          </Form.Actions>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const locale = {
  en: {
    title: 'Duplicate form',
    confirm: 'Duplicate form',
    formName: 'Form name',
    copy: 'copy',
  },
};
